module.exports = "/_next/static/images/bg-call-3012e157342034c8a839932d7a333eed.jpg";